<template>
  <vx-card no-shadow>
    <vs-popup
      fullscreen
      :title="popupTitle"
      :active.sync="popupActive"
      v-if="meta != null"
    >
      <b>Details</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Label"
            label-placeholder="Label"
            v-model="meta.label"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Label"
            label-placeholder="Reference"
            v-model="meta.ref"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            type="date"
            name="Trip Date"
            label-placeholder="Date"
            v-model="meta.date"
            class="w-full"
          />
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            type="time"
            name="Trip Time"
            label-placeholder="Time"
            v-model="meta.time"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:3'"
            data-vv-validate-on="blur"
            name="remarks"
            label-placeholder="Remarks"
            v-model="meta.remarks"
            class="w-full"
          />
        </div>
        <br />
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-2/4 w-half">
          <label
            >Recurring Trip ? * New Trip Record will be created
            repeatedly</label
          >
          <vs-switch v-model="meta.recurring">
            <span slot="on">YES</span>
            <span slot="off">NO</span>
          </vs-switch>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            type="number"
            name="Repeat Days Count"
            label-placeholder="Repeat Days Count?"
            v-model="meta.repeat"
            class="w-full"
          />
        </div>
        <br />
      </div>
      <br />
      <hr />
      <b>Assignment</b>
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect
            id="multiselect"
            :fields="parameterFields"
            v-model="meta.vessel"
            :dataSource="vesselData"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Vessel"
            maximumSelectionLength="1"
          ></ejs-multiselect>
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect
            id="multiselect"
            :fields="parameterFields"
            v-model="meta.captain"
            :dataSource="captainData"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Captain"
            maximumSelectionLength="1"
          ></ejs-multiselect>
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect
            id="multiselect"
            :fields="parameterFields"
            v-model="meta.crew"
            :dataSource="crewData"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Crew(s)"
          ></ejs-multiselect>
        </div>
        <br />
      </div>
      <br />
      <hr />
      <b>Manifest</b>
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Passenger Capacity (inc Capt. & Crew)"
            label-placeholder="Passenger Capacity (inc Capt. & Crew)"
            v-model="meta.capacity"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Num of Seats - Disabilities"
            label-placeholder="Num of Seats - Disabilities"
            v-model="meta.disability_seats"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Num of Seats - Pregnant"
            label-placeholder="Num of Seats - Pregnant"
            v-model="meta.pregnant"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Num of Seats - Children below 8 years"
            label-placeholder="Num of Seats - Children below 8 years"
            v-model="meta.children"
            class="w-full"
          />
        </div>
        <br />
      </div>
      <br />
      <hr />
      <feather-icon
        icon="UploadIcon"
        size="16"
        color="success"
        class="align-text-bottom"
      />
      <b
        >&nbsp;To upload large data easily, use our
        <a
          href="https://api.igeotechgps.com/uploads/%5BTEMPLATE%5D%20Upload%20Trip%20Manifest.xlsx"
          target="_blank"
          >BULK UPLOAD TEMPLATE</a
        >. Fill up the Excel sheet as per the given instructions, and upload.</b
      >
      <br /><br />
      <label>Upload DATA file &nbsp;&nbsp;</label>
      <input
        type="file"
        ref="fileInput"
        @change="csvToJSON($event)"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />
      <br><br>
      <label
            >Overwrite Existing Data? Select YES to overwrite any existing data. SELECT NO to ADD to existing data.</label
          >
          <vs-switch v-model="overwrite" size="sm">
            <span slot="on">YES</span>
            <span slot="off">NO</span>
          </vs-switch>

      <br /><br />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>Passenger List</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addPassenger('add')"
            >Add Passenger</vs-button
          >
        </div>
        <!-- <div class="vx-col md:w-1/8 w-half">
      <input type="file" ref="file" style="display: none" />
          <vs-button color="primary" size="small" type="border" icon-pack="feather" icon="icon-upload" @click="uploadFile()">Import by Excel Sheet</vs-button>
    </div> -->
      </div>
      <br />

      <div class="vx-row">
        <div class="vx-col md:w-3/3 w-full">
          <vs-table stripe :data="meta.passengers" maxHeight="40vh">
            <template slot="thead">
              <vs-th width="5%">No.</vs-th>
              <vs-th>Full Name</vs-th>
              <vs-th>Nationality</vs-th>
              <vs-th>Gender</vs-th>
              <vs-th>Age</vs-th>
              <vs-th>Seat</vs-th>
              <vs-th>ID</vs-th>
              <vs-th>Remarks</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span>
                    <b>{{ indextr + 1 }}.</b></span
                  >
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.passengers[indextr].name"
                    label-placeholder="Full Name"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.passengers[indextr].nationality"
                    label-placeholder="Nationality"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.passengers[indextr].gender"
                    label-placeholder="Gender"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.passengers[indextr].age"
                    label-placeholder="Age"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.passengers[indextr].seat"
                    label-placeholder="Seat"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.passengers[indextr].id"
                    label-placeholder="ID"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.passengers[indextr].remark"
                    label-placeholder="Remarks"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-button
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="removePassenger(indextr)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/3 w-full"></div>
        <br />
      </div>
      <br />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>Cargo List</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addCargo('add')"
            >Add Cargo</vs-button
          >
        </div>
        <!-- <div class="vx-col md:w-1/8 w-half">
      <input type="file" ref="file" style="display: none" />
          <vs-button color="primary" size="small" type="border" icon-pack="feather" icon="icon-upload" @click="uploadFile()">Import by Excel Sheet</vs-button>
    </div> -->
      </div>
      <br />

      <div class="vx-row">
        <div class="vx-col md:w-3/3 w-full">
          <vs-table stripe :data="meta.cargo" maxHeight="40vh">
            <template slot="thead">
              <vs-th width="5%">No.</vs-th>
              <vs-th>Owner Name</vs-th>
              <vs-th>Owner Contact</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Volume</vs-th>
              <vs-th>Quantity</vs-th>
              <vs-th>Charges</vs-th>
              <vs-th>Remarks</vs-th>
              <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span>
                    <b>{{ indextr + 1 }}.</b></span
                  >
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.cargo[indextr].owner_name"
                    label-placeholder="Owner Name"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.cargo[indextr].owner_contact"
                    label-placeholder="Owner Contact"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.cargo[indextr].type"
                    label-placeholder="Cargo Type"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.cargo[indextr].volume"
                    label-placeholder="Volume"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.cargo[indextr].quantity"
                    label-placeholder="Quantity"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.cargo[indextr].charges"
                    label-placeholder="Charges"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.cargo[indextr].remark"
                    label-placeholder="Remarks"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-button
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="removeCargo(indextr)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/3 w-full"></div>
        <br />
      </div>
      <hr />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>Notification Channels</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addContact('add')"
            >Add Channel</vs-button
          >
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="showChannels()"
            >Select from Existing Channels</vs-button
          >
        </div>
      </div>
      <br />
      <div v-if="showExistingChannels">
        <div class="vx-row">
          <div class="vx-col md:w-1/8 w-half">
            <b>Current Channels</b>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-2/3 w-full">
            <vs-table stripe :data="existingChannels" max-height="500">
              <template slot="thead">
                <vs-th width="5%">No.</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Detail</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>
                      <b>{{ indextr + 1 }}.</b></span
                    >
                  </vs-td>
                  <vs-td>
                    {{ tr.type }}
                  </vs-td>
                  <vs-td>
                    {{ tr.detail }}
                  </vs-td>
                  <vs-td>
                    {{ tr.remark }}
                  </vs-td>
                  <vs-td>
                    <vs-button
                      color="success"
                      type="border"
                      icon-pack="feather"
                      icon="icon-check"
                      @click="addContactExisting(indextr)"
                      >Add</vs-button
                    >
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-col md:w-1/3 w-full"></div>
          <br />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-2/3 w-full">
          <vs-table stripe :data="meta.channels" max-height="500">
            <template slot="thead">
              <vs-th width="5%">No.</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Detail</vs-th>
              <vs-th>Remarks</vs-th>
              <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span>
                    <b>{{ indextr + 1 }}.</b></span
                  >
                </vs-td>
                <vs-td>
                  <v-select
                    placeholder="Select Type"
                    clearable="false"
                    :options="['Telegram', 'Email', 'SMS']"
                    v-model="meta.channels[indextr].type"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.channels[indextr].detail"
                    label-placeholder="Details"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.channels[indextr].remark"
                    label-placeholder="Remarks"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-button
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="removeContact(indextr)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/3 w-full"></div>
        <br />
      </div>
      <hr />
      <br />
      <hr />
      <br />
      <b>Notification Configuration</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="First Reminder"
            label-placeholder="First Reminder - Number of Days"
            v-model="meta.reminder_one_days"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Second Reminder"
            label-placeholder="Second Reminder - Number of Days"
            v-model="meta.reminder_two_days"
            class="w-full"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="First Reminder"
            label-placeholder="First Reminder - Nautical Miles Travelled"
            v-model="meta.reminder_one_mileage"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Second Reminder"
            label-placeholder="Second Reminder - Nautical Miles Travelled"
            v-model="meta.reminder_two_mileage"
            class="w-full"
          />
        </div>
      </div>
      <br />
      <vs-button
        v-if="mode == 'add'"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        @click="postData('add')"
        >Add New Trip</vs-button
      >
      <br />
      <div v-if="mode == 'update'">
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            Created Profile: <b>{{ meta.create_time }}</b>
          </div>
          <div class="vx-col md:w-1/4 w-half" v-if="meta.update_time != null">
            Last Updated : <b>{{ meta.update_time }}</b>
          </div>
        </div>
        <br />

        <br /><br />
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-pen"
              @click="postData('update')"
              >Update Trip Profile</vs-button
            >
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash"
              @click="postData('delete')"
              >Delete Trip Profile</vs-button
            >
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-copy"
              @click="duplicateData()"
              >Duplicate Trip Profile</vs-button
            >
          </div>
        </div>
        <br />
      </div>

      <br />
    </vs-popup>

    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>

    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-half">
        <vs-button size="small" @click="addTemplate">Add New Trip</vs-button>
      </div>
    </div>

    <br />

    <ejs-grid
      :dataSource="templateData"
      :allowExcelExport="true"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick"
      :allowTextWrap="true"
      height="40vh"
      gridLines="Both"
      :filterSettings="filterOptions"
      :allowPaging="true"
      :searchSettings="searchOptions"
      :toolbar="toolbarOptions"
      ref="tripTemplateGrid"
      id="tripTemplateGrid"
      :pageSettings="pageSettings"
      :showColumnChooser="true"
      :allowSorting="true"
      :allowMultiSorting="true"
      :allowFiltering="true"
    >
      <e-columns>
        <e-column
          field="no"
          headerText="No."
          textAlign="Left"
          width="80"
        ></e-column>
        <e-column
          field="label"
          headerText="Label"
          textAlign="Left"
          width="150"
        ></e-column>
        <e-column
          field="ref"
          headerText="Reference"
          textAlign="Left"
          width="150"
        ></e-column>
        <e-column
          field="datetime"
          headerText="Date-Time"
          textAlign="Left"
          width="150"
        ></e-column>
        <e-column
          field="update_time"
          headerText="Last Updated"
          textAlign="Left"
          width="100"
        ></e-column>
        <e-column
          field="owner"
          headerText="Manager"
          textAlign="Left"
          width="100"
        ></e-column>
        <e-column
          headerText="Manage"
          textAlign="Left"
          :template="cTemplate"
          width="100"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </vx-card>
</template>

<script>
var today = new Date();
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './editButtonTemplate1.vue';
import columntempVue2 from './editButtonTemplate2.vue';
import vSelect from 'vue-select';
import axios from '@/axios.js';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { getBaseURL } from '@/config.js';
import { Workbook } from 'exceljs';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue,
    vueDropzone: vue2Dropzone,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      isLoading: false,
      mode: 'add',
      overwrite:false,
      popupActive: false,
      popupTitle: 'Add New Trip',
      templateData: [],
      vesselData: [],
      crewData: [],
      captainData: [],
      userData: [
        {
          userGroup: 'Default',
          name: `${
            JSON.parse(localStorage.getItem('userInfo')).displayName
          } | ${JSON.parse(localStorage.getItem('userInfo')).username}`,
          id: JSON.parse(localStorage.getItem('userInfo')).uid,
        },
      ],
      groupData: [{ groupGroup: 'Default', name: 'All Units Assigned', id: 0 }],
      meta: null,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      searchOptions: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      cTemplate() {
        return { template: columntempVue };
      },
      cTemplate2() {
        return { template: columntempVue2 };
      },
      showExistingChannels: false,
      existingChannels: [],
      parameterOptionsChannels: [
        {
          val: 'Telegram',
          label: 'Telegram',
        },
        {
          val: 'Email',
          label: 'Email',
        },
      ],
      parameterFields: { text: 'label', value: 'val' },
      dropzoneOptions: {
        acceptedFiles: 'image/*',
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
    };
  },
  computed: {},
  methods: {
    async csvToJSON(event) {
      const self = this;
      const file = event.target.files.item(0);
      await self.validateExcelFile(file);
    },
    async validateExcelFile(file) {
      const self = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;
          const workbook = new Workbook();
          workbook.xlsx
            .load(buffer)
            .then(() => {
              if(self.overwrite==true){
                self.meta.passengers=[];
                self.meta.cargo=[];
              }
              const passengerWorksheet = workbook.getWorksheet(2);
              const cargoWorksheet = workbook.getWorksheet(3);
              passengerWorksheet.eachRow(function (row, rowNumber) {
                if (rowNumber > 5) {
                  self.meta.passengers.push({
                    name: row.values[1],
                    nationality: row.values[2],
                    gender: row.values[3],
                    age: row.values[4],
                    seat: row.values[5],
                    id: row.values[6],
                  });
                }
              });
              cargoWorksheet.eachRow(function (row, rowNumber) {
                if (rowNumber > 5) {
                  self.meta.cargo.push({
                    owner_name: row.values[1],
                    owner_contact: row.values[2],
                    type: row.values[3],
                    volume: row.values[4],
                    quantity: row.values[5],
                    charges: row.values[6],
                    remark: row.values[7],
                  });
                }
              });
            }).catch((error) => {
              reject('Error occurred while loading the workbook.');
            }).finally(() => {
            self.$refs.fileInput.value = '';
        });
        };
      });
    },
    duplicateData() {
      const self = this;
      self.popupActive = false;
      self.mode = 'add';
      self.popupTitle = 'Add New Trip';
      self.popupActive = true;
    },
    fileUploaderLocal(files, response, key) {
      const x = response.path;
      const str = x.substring(25);
      this.meta[key].push(str);
    },
    fileRemoverCloud(key, index) {
      const self = this;
      self.meta[key].splice(index, 1);
    },
    fileRemoverLocal(file, key) {
      const self = this;
      const removedFile = file.upload.filename;
      const arr = self.meta[key];
      if (arr.length == 1) {
        self.meta[key] = [];
        return;
      }
      arr.forEach((element, i) => {
        const y = element.split('_', 4);
        if (y[3].includes(removedFile)) {
          self.meta[key].splice(i, 1);
        }
      });
    },
    sanitizeLink(link) {
      const y = link.split('_', 4);
      return `-> ${y[3]}`;
    },
    unitFiltering(args) {
      const self = this;
      const searchData = self.unitSelection;
      let query = new Query();
      let predicate = new Predicate('assetName', 'contains', args.text, true);
      predicate = predicate.or('assetGroup', 'contains', args.text, true);
      query = args.text != '' ? query.where(predicate) : query;

      args.updateData(searchData, query);
    },
    showChannels() {
      this.showExistingChannels = !this.showExistingChannels;
    },
    removeContact(index) {
      this.meta.channels.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed Channel',
        color: 'success',
      });
    },
    addContact() {
      this.meta.channels.push({ type: '', detail: '', remark: '' });
      this.$vs.notify({
        time: 4000,
        text: 'Added Empty Channel',
        color: 'success',
      });
    },
    addContactExisting(index) {
      this.meta.channels.push({
        type: this.existingChannels[index].type,
        detail: this.existingChannels[index].detail,
        remark: this.existingChannels[index].remark,
      });
      this.$vs.notify({
        time: 4000,
        text: 'Added Existing Channel',
        color: 'success',
      });
    },
    removePassenger(index) {
      this.meta.passengers.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed Passenger',
        color: 'success',
      });
    },
    addPassenger() {
      this.meta.passengers.push({
        name: 'John Hammond',
        nationality: 'Maldives',
        gender: 'MALE',
        age: 30,
        seat: '1A',
        id: 'IC/PASS',
      });
      this.$vs.notify({
        time: 4000,
        text: 'Added Empty Passenger',
        color: 'success',
      });
    },
    removeCargo(index) {
      this.meta.cargo.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed Cargo',
        color: 'success',
      });
    },
    addCargo() {
      this.meta.cargo.push({
        owner_name: '',
        owner_contact: '',
        type: '',
        volume: '',
        quantity: '',
        consignee: '',
        charges: '',
        remark:
          'Vessel Details:   | Registry Number: | Location/Jetty/Harbour: | Loaded Date & Time:',
      });
      this.$vs.notify({
        time: 4000,
        text: 'Added Empty Cargo',
        color: 'success',
      });
    },
    validateTemplate() {
      const self = this;
      return new Promise((resolve, reject) => {
        if (self.meta.label.length < 5) {
          reject('Label field is mandatory. Minimum 5 characters.');
        }
        if (self.meta.ref.length < 5) {
          reject('Reference field is mandatory. Minimum 5 characters.');
        }
        if (self.meta.date == null) {
          reject('Date field is mandatory. Select to continue.');
        }
        if (self.meta.time == null) {
          reject('Time field is mandatory. Select to continue.');
        }
        if (self.meta.capacity < 1) {
          reject('Capacity must be more than 0.');
        }
        if (self.meta.vessel == null) {
          reject('Vessel assignment is mandatory. Select to continue.');
        }
        if (self.meta.captain == null) {
          reject('Captain assignment is mandatory. Select to continue.');
        }
        if (self.meta.crew == null) {
          reject('Crew assignment is mandatory. Select to continue.');
        } else resolve(true);
      });
    },
    addTemplate() {
      const self = this;
      self.mode = 'add';
      self.popupTitle = 'Add New Trip';
      self.meta = {
        label: '',
        ref: '',
        date: null,
        time: null,
        recurring: false,
        repeat: 0,
        remarks: '',
        capacity: 0,
        disability_seats: 0,
        pregnant: 0,
        children: 0,
        vessel: null,
        captain: null,
        crew: null,
        passengers: [],
        cargo: [],
        channels: [],
        createdById: self.userInfo.uid,
        createdByMeta: {
          uid: JSON.parse(localStorage.getItem('userInfo')).uid,
          email: JSON.parse(localStorage.getItem('userInfo')).email,
          username: JSON.parse(localStorage.getItem('userInfo')).username,
          userRole: JSON.parse(localStorage.getItem('userInfo')).userRole,
          displayName: JSON.parse(localStorage.getItem('userInfo')).displayName,
        },
      };
      self.popupActive = true;
    },
    editTemplate(data) {
      const self = this;
      self.mode = 'update';
      self.meta = JSON.parse(data.meta);
      self.popupTitle = `Update Trip ${self.meta.label}`;
      self.meta.id = data.id;
      self.popupActive = true;
    },
    getData() {
      const self = this;
      axios
        .post(
          `https://api.igeotechgps.com/api-vms/get-profiles/${self.userInfo.uid}/${self.userInfo.userRole}/Trip`,
          {
            adtlAccess: self.userInfo.access.actions.includes('vessel-agency'),
            adtlAttributes: true,
          },
        )
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.templateData = response.data.templateData;
            self.crewData = response.data.crewData;
            self.captainData = response.data.captainData;
            self.vesselData = response.data.vesselData;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    postData(type, data) {
      const self = this;
      let url;
      let successText;
      let successTitle;
      let failureText;
      let profile = 'Trip';
      if (type == `add`) {
        url = `https://api.igeotechgps.com/api-vms/add-profile`;
        successText = `Note: Newly added ${profile} could take upto 2 hours to activate alerts`;
        successTitle = `Added New ${profile}`;
        failureText = `Could not add ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
      }
      if (type == `update`) {
        url = `https://api.igeotechgps.com/api-vms/update-profile`;
        successText = `Note: Updated ${profile} configurations could take upto 2 hours to activate alerts`;
        successTitle = `Updated ${profile}`;
        failureText = `Could not Update ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
      }
      if (type == `delete`) {
        url = `https://api.igeotechgps.com/api-vms/delete-profile`;
        successText = `Note: Deleted ${profile} could take upto 2 hours to de-activate alerts`;
        successTitle = `Deleted ${profile}`;
        failureText = `Could not delete ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
        const text = `${profile} deletion action is PERMANENT & IRREVERSIBLE. Continue? `;
        if (confirm(text) == false) {
        }
      }
      if (type == `add` || type == `update`) {
        self
          .validateTemplate()
          .then((result) => {
            self.confirmPostData(
              url,
              successText,
              successTitle,
              failureText,
              profile,
            );
          })
          .catch((error) => {
            self.$vs.notify({
              time: 5000,
              title: error,
              color: `warning`,
            });
          });
      } else {
        self.confirmPostData(
          url,
          successText,
          successTitle,
          failureText,
          profile,
          data,
        );
      }
    },
    confirmPostData(
      url,
      successText,
      successTitle,
      failureText,
      profile,
      data,
    ) {
      const self = this;
      let meta;
      if (data) {
        meta = JSON.parse(data.meta);
      } else {
        meta = self.meta;
      }
      axios
        .post(url, {
          userInfo: self.userInfo,
          type: profile,
          meta: meta,
        })
        .then(function (response) {
          self.popupActive = false;
          if (response.status == 200 && response.data.success) {
            self.$vs.notify({
              time: 10000,
              text: successText,
              title: successTitle,
              color: 'success',
            });
            self.getData();
            self.getData2();
          } else {
            self.$vs.notify({
              time: 8000,
              title: failureText,
              color: 'warning',
            });
            if (response.data.error) {
            } else {
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toolbarClick(args) {
      if (args.item.id === 'tripTemplateGrid_excelexport') {
        var exportProperties = {
          fileName: 'Trips - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.tripTemplateGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'tripTemplateGrid_pdfexport') {
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Trips - Listing.pdf',
        };
        this.$refs.tripTemplateGrid.pdfExport(exportProperties);
      }
    },
    getData2() {
      const self = this;
      let uid = self.userInfo.uid;
      if (self.userInfo.access.actions.includes('events-staff')) {
        uid = 1;
      }
      self.$http
        .get(`admin/users/main/${uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            response.data.userData.forEach(function (element) {
              self.userData.push({
                id: element.id,
                name: element.username,
                userGroup: 'User Created',
              });
            });
            response.data.groupData.forEach(function (element) {
              self.groupData.push({
                id: element.id,
                name: element.name,
                groupGroup: 'User Created',
              });
            });
            axios
              .post('https://api.igeotechgps.com/api-events/get-channels', {
                userIds: self.userData,
              })
              .then(function (response) {
                if (response.status == 200 && response.data.success) {
                  self.existingChannels = response.data.existingChannels;
                }
              });
          }
        })
        .catch(function (error) {});
    },
  },
  watch: {},
  mounted() {
    this.getData();
    this.getData2();
  },
};
</script>

<style>
.e-grid .e-excelexport {
  color: green;
  font-weight: bold;
}

.e-grid .e-pdfexport {
  color: red;
  font-weight: bold;
}

#map {
  height: 80vh;
}

#map2 {
  height: 80vh;
}

@import '../../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
</style>
